import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { ProductCard } from '../shop/ProductCard';
import { SectionHeading } from '../ui/SectionHeading';
import { products } from '../../data/products';
export function PharmacyPreview() {
  const featured = [products[0], products[2], products[6]];
  return <section className="bg-cream-deep" data-id="element-86" data-mp="kk0ioydntvzf">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-87" data-mp="189l5xtgujfei">
        <div className="flex flex-wrap items-end justify-between gap-8" data-id="element-88" data-mp="18bp55y3svq8g">
          <SectionHeading eyebrow="Pharmacy" title="FDA-approved medications and US-compounded peptides, priced in public." intro="Browse the full catalogue with the monthly cost, the form, the strength and the dispensing pharmacy stated before you request anything." data-id="element-89" data-mp="1caeu8ny7aw7x" />
          <Link to="/shop" className="group inline-flex items-center gap-2 pb-2 text-sm text-ink transition-colors duration-150 ease-republic hover:text-brick" data-id="element-90" data-mp="1r645br1uloxv">
            See all prices
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-republic group-hover:translate-x-1" data-id="element-91" data-mp="cqa0du08qewg" />
          </Link>
        </div>

        <ul className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-92" data-mp="qj9i82nhwl76">
          {featured.map(product => <ProductCard key={product.slug} product={product} data-id="element-93" data-mp="lpnbss7xddjt" />)}
        </ul>
      </div>
    </section>;
}